export class GantOrderAcceptanceRequest {
  id: number;
  poNumber: string;
  style: string;
  itemNo: string;
  deliveryDate: string;
  shipMode: string;
  deliveryAddress: string;
}

export class GantApproveRequest {
  coReqDetails: {
    id: number;
    poNumber: string;
    style: string;
    itemNo: string;
    deliveryDate: string;
    shipMode: string;
    deliveryAddress: string;
    colorCode: string;
  }[]

}